import * as actions from '../actions/create-pin'
import Immutable from 'seamless-immutable'

const initialState = Immutable({
	// General
	step: 1,

	// Step 1
	pin1: '',
	pin1Error: '',

	// Step 2
	pin2: '',
	pin2Error: '',

	// Submit
	submitError: ''
})

export default function (state = initialState, action){
	switch(action.type){
		case actions.STORE_PIN:
			if(action.page == 2 && state.pin1 !== action.pin){
				action.validation = 'PIN must match previous page'
			}

			return state
				.merge({
					[`pin${action.page}`]: action.pin,
					[`pin${action.page}Error`]: action.validation
				})

		case actions.NEXT_STEP:
			return state.set('step', state.step + 1)

		case actions.PREVIOUS_STEP:
			return state.set('step', state.step == 1 ? 1 : state.step - 1)

		case actions.RESET_STATE:
			return initialState

	}
	return state
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/reducers/create-pin.js